module.exports = __webpack_public_path__ + "img/selected2-min.6e934768.png";